import { render, staticRenderFns } from "./PTable.vue?vue&type=template&id=0955d910&scoped=true"
import script from "./PTable.vue?vue&type=script&lang=ts"
export * from "./PTable.vue?vue&type=script&lang=ts"
import style0 from "./PTable.vue?vue&type=style&index=0&id=0955d910&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0955d910",
  null
  
)

export default component.exports